import { Module } from 'vuex';
import { ApplicationState } from '@/store/modules/application/application-state.model';
import { ApplicationLayout } from '@/store/modules/application/application-layout.model';
import { WebAppConfig } from '@/connectors/configs/web-app-config.model';
import router from '@/router';
import { ConfigsConnector } from '@/connectors/configs/configs.connector';

const configsConnector: ConfigsConnector = new ConfigsConnector();

export const ApplicationModule: Module<ApplicationState, any> = {
  namespaced: true,
  state: {
    layout: ApplicationLayout.login,
    title: '',
    config: {
      bundleStatisticsPollingDelayInSeconds: 1
    }
  },
  mutations: {
    changeLayout(s: ApplicationState, p: ApplicationLayout) {
      s.layout = p;
    },
    changeTitle(s: ApplicationState, p: string) {
      s.title = p;
    },
    updateConfig(s: ApplicationState, p: WebAppConfig) {
      s.config = p;
    }
  },
  actions: {
    async fetchConfig(ctx) {
      const fetchedConfig = await configsConnector.getWebAppConfig();

      await ctx.commit('updateConfig', fetchedConfig);
    }
  },
  getters: {
    layout(state) {
      return state.layout;
    }
  }
};
